import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { AppProvider } from './AppProvider';
import { amplitudeTracker } from '../lib/shared/amplitude-tracker';
import { logEvent } from '../lib/shared/event-logger';
import { EVENT_TYPES } from '../lib/shared/event-types';
import { setCustomHeightVariable } from '../lib/shared/dimension-helpers';
import config from '../config';
import '../lib/shared/facebook-tracker';

amplitudeTracker.init(config.amplitudeApiKey);

function App() {
    useEffect(() => {
        setCustomHeightVariable();
        window.addEventListener('resize', setCustomHeightVariable);
        logEvent(EVENT_TYPES.PAGE_VIEW);
    }, []);

    return (
        <>
            <ScrollToTop />
            <AppProvider>
                <Outlet />
            </AppProvider>
        </>
    );
}

export {
    App
};
